/**
 * An automated or manual TEST run, marked so it never reads as a real visitor (2026-10-04).
 *
 * On 2026-10-03 a journey test ran with a real ad's utm_content and an fbclid and pressed Build with
 * the owner's account: in the log it was ad traffic, and it may have reached Meta. A visit opened with
 * `test=1` in its address is now a test for the rest of the tab: every first-party event carries
 * `test: true`, and the Meta pixel does not load at all.
 */
const KEY = 'saddle.test';

/**
 * Meta's own visits, which are not people (2026-10-20, landing_pages/docs/event-audit-handoff.md): Ads Manager's
 * preview links carry the literal `fbclid=fbclid`, and its link checker is a crawler. On Oct 20 they logged 17
 * one-page "ad visits" for draft ads that never ran. They count as tests: no first-party numbers, no pixel.
 */
const META_CRAWLER = /facebookexternalhit|facebookcatalog|meta-externalagent|meta-externalfetcher|facebot/i;
export function isMetaCheck(search: string, userAgent: string): boolean {
  return new URLSearchParams(search).get('fbclid') === 'fbclid' || META_CRAWLER.test(userAgent);
}

export function isTestVisit(): boolean {
  try {
    const search = typeof location !== 'undefined' ? location.search : '';
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    if (new URLSearchParams(search).get('test') === '1' || isMetaCheck(search, ua)) {
      sessionStorage.setItem(KEY, '1');
      return true;
    }
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}
